import React, { useEffect, useMemo } from 'react';
import {
  Box,
  Button,
  Container,
  IconButton,
  LinearProgress,
  makeStyles
} from '@material-ui/core';
import { Page } from 'src/components';

import { PageModuleTitle } from 'src/components/PageModuleTitle';
import PaymentIcon from '@material-ui/icons/Payment';
import { Toolbar } from './components/Toolbar';
import { ChequeListTable } from './components/ChequeListTable';
import { useCheque } from 'src/hooks/cheque-management/use-cheque';
import useResolution from 'src/hooks/useResolution';
import AddIcon from '@material-ui/icons/Add';
import { useLocation, useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  productCard: {
    height: '100%'
  }
}));

export const component = () => {
  const classes = useStyles();
  const { fetchChequeList, setChequeListParams } = useCheque();
  const { isMobile } = useResolution();
  const navigate = useNavigate();

  const location = useLocation();

  const [alreadyFetched, setAlreadyFetched] = React.useState<boolean>(false);

  const initialParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const params: any = {};

    searchParams.forEach((value, key) => {
      if (value === 'undefined' || value === '') {
        params[key] = undefined;
      } else if (!isNaN(Number(value))) {
        params[key] = Number(value);
      } else {
        params[key] = value;
      }
    });

    return params;
  }, [location.search]);

  const { isLoading, chequeList } = useCheque();

  //initialize url params
  useEffect(() => {
    setChequeListParams(initialParams);

    if (
      initialParams &&
      Object.keys(initialParams).length > 0 &&
      !alreadyFetched
    ) {
      fetchChequeList({ ...initialParams });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialParams]);

  //This is for auto fetch to page 1 if no cheque found
  useEffect(() => {
    // Reset to page 1 if not already page 1
    if (
      initialParams.page !== 1 &&
      chequeList &&
      chequeList?.length <= 0 &&
      alreadyFetched
    ) {
      const newParams = { ...initialParams, page: 1 };
      fetchChequeList(newParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialParams, chequeList]);

  return (
    <Page className={classes.root} title="Cheque Management">
      <Container maxWidth={false}>
        <PageModuleTitle
          icon={PaymentIcon}
          title="Cheque Management"
          rightContent={
            <>
              {isMobile ? (
                <IconButton
                  color="primary"
                  onClick={() => navigate('/app/cheque/add')}
                  size="small"
                  style={{ border: '1px solid currentColor' }}
                >
                  <AddIcon />
                </IconButton>
              ) : (
                <Button
                  color="primary"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => navigate('/app/cheque/add')}
                >
                  Create Cheque
                </Button>
              )}
            </>
          }
        />
        <Toolbar onHandleAppliedFilter={() => setAlreadyFetched(true)} />
        {isLoading ? <LinearProgress /> : null}
        {chequeList && chequeList.length > 0 ? (
          <>
            <Box sx={{ mt: 3 }}>
              <ChequeListTable onHandleAppliedFilter={() => setAlreadyFetched(true)} />
            </Box>
          </>
        ) : null}
      </Container>
    </Page>
  );
};

export const ChequeManagement = React.memo(component);
